<script setup lang="ts">

  interface Props {
    notices: { title: string; content: string; }[] | null,
  }

  defineProps<Props>();
</script>
<template>
  <UiModal large visitable open>
    <div class="notice" v-for="notice in notices" :key="notice.title">
      <div class="notice-title" v-html="notice.title" />
      <div class="notice-content" v-html="notice.content" />
    </div>
    <UiButtonGroup>
      <SfButton primary :href="$route('web.cart.note.edit')">
        {{ $t('SHOP.ACTION.ACCEPT_AND_CONTINUE') }}
      </SfButton>
      <SfButton back>
        {{ $t('SHOP.ACTION.BACK') }}
      </SfButton>
    </UiButtonGroup>
  </UiModal>

  <RouterView />
</template>
<style scoped lang="scss">
  .notice {
    display: flex;
    flex-direction: column;
    line-height: 1.75rem;
    font-size: 0.75rem;
    gap: 2rem;

    .notice-title {
      font-size: 1.2rem;
      font-weight: var(--font-weight-bold);
    }

    .notice-content {
      color: var(--secondary-color);

      :deep(ul) {
        padding-left: 2rem;
      }
    }
  }
</style>
